import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"right\"><title>right</title><path d=\"M4.703 14q.234 0 .422-.156l6.625-5.328q.25-.203.25-.531t-.25-.531L5.156 2.157q-.219-.172-.5-.141t-.461.25-.148.5.25.453l5.938 4.766-5.969 4.797q-.219.172-.25.453t.141.5q.219.266.547.266z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/right.svg
// module id = 526
// module chunks = 0